var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 20,
    viewBox: "0 0 52 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3467 19.9986H29.5532C33.1726 19.8168 35.7062 16.9685 35.7062 13.5747C35.7062 12.4232 35.4649 11.2717 34.922 10.3627H28.3467V19.9986Z",
    fill: "#FF000F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7511 10.3031H21.7188V19.9997H27.7511V10.3031Z",
    fill: "#FF000F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.56 9.69657C33.9568 8.84812 33.1123 8.18148 32.2074 7.69665C33.2932 6.9088 34.0171 5.63613 34.0171 4.24225C34.0171 1.87871 32.1471 0 29.7944 0H28.3467V9.69657H34.56Z",
    fill: "#FF000F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7511 0H21.7188V9.69657H27.7511V0Z",
    fill: "#FF000F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6396 19.9986H45.8461C49.4655 19.8168 51.9991 16.9685 51.9991 13.5747C51.9991 12.4232 51.7578 11.2717 51.2149 10.3627H44.6396V19.9986Z",
    fill: "#FF000F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0333 10.3031H38.001V19.9997H44.0333V10.3031Z",
    fill: "#FF000F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.853 9.69657C50.2498 8.84812 49.4052 8.18148 48.5004 7.69665C49.5862 6.9088 50.3101 5.63613 50.3101 4.24225C50.3101 1.87871 48.44 0 46.0874 0H44.6396V9.69657H50.853Z",
    fill: "#FF000F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0333 0H38.001V9.69657H44.0333V0Z",
    fill: "#FF000F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43845 10.3031L0 19.9997H5.00687L6.45463 15.7574H9.65179V10.3031H3.43845Z",
    fill: "#FF000F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64858 0H7.05466L3.61621 9.69657H9.64858V0Z",
    fill: "#FF000F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.249 15.7574H13.4462L14.8939 19.9997H19.9008L16.4624 10.3031H10.249V15.7574Z",
    fill: "#FF000F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2814 9.69657L12.8429 0H10.249V9.69657H16.2814Z",
    fill: "#FF000F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbbLogo);
export default __webpack_public_path__ + "static/media/ABB_logo.058b27870737a80e8f883caf3cc8a422.svg";
export { ForwardRef as ReactComponent };